import EventRegistrationComp from '../../components/portal/EventRegistration';

const EventRegistration = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <EventRegistrationComp />
    </div>
  );
};

export default EventRegistration; 